import DOMPurify from 'dompurify';
import { registerCustomElement } from '../utils.mjs';

export class HTML extends HTMLElement {
	/**
	 * Builds the separator dom.
	 *
	 * @param instructions {object} Collection of directives.
	 */

	async build(instructions) {
		this.setAttribute('name', instructions.name || '');
		this.className = 'form-group';

		const hook = (node) => {
			if (node.tagName !== 'A') return;

			node.setAttribute('target', '_blank');
		};

		// Make links open in a new tab
		DOMPurify.addHook('afterSanitizeAttributes', hook);

		const purifiedHTML = DOMPurify.sanitize(instructions.label, {
			FORBID_TAGS: ['iframe'],
			FORBID_ATTR: ['srcdoc'],
			ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
		});

		// Remove global hook
		DOMPurify.removeHook('afterSanitizeAttributes', hook);

		this.innerHTML = purifiedHTML;
	}
}

// TODO: deprecated - will be removed
registerCustomElement('imt-input-html', class extends HTML {});
registerCustomElement('imt-visual-html', HTML);
